import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { useRef, useState } from 'react';

import Box from '~/common/components/Box';
import Tooltip from '~/common/mui/MUITooltip/MUITooltip';

import {
  StyledCopyableBox,
  StyledFontAwesomeIcon,
  StyledTextBox,
  arrowStyle,
  tooltipStyle,
} from './Styled';

type CopyableTextWithTooltipProps = {
  text: string;
  valueToCopy: string;
  textStyle?: object;
  maxWidth?: string | number;
  dataTestId?: string;
};

const CopyableTextWithTooltip = ({
  text,
  valueToCopy,
  textStyle = {},
  maxWidth,
  dataTestId,
}: CopyableTextWithTooltipProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(valueToCopy);
      if (timerRef.current) clearTimeout(timerRef.current);
      setTooltipOpen(true);
      timerRef.current = setTimeout(() => setTooltipOpen(false), 1200);
    } catch {
      setTooltipOpen(false);
    }
  };

  return (
    <Tooltip
      open={tooltipOpen}
      title="Copied!"
      arrow
      placement="bottom"
      slotProps={{
        tooltip: { sx: { ...tooltipStyle } },
        arrow: { sx: { ...arrowStyle } },
        transition: { timeout: { enter: 200, exit: 200 } },
      }}
    >
      <Box onClick={handleCopy}>
        <StyledCopyableBox
          sx={{
            ...(maxWidth ? { maxWidth } : {}),
          }}
        >
          <StyledTextBox
            sx={{
              ...textStyle,
            }}
            data-testid={dataTestId ? `${dataTestId}-text` : undefined}
          >
            {text}
          </StyledTextBox>
          <StyledFontAwesomeIcon className="faCopy-icon" icon={faCopy} />
        </StyledCopyableBox>
      </Box>
    </Tooltip>
  );
};

export default CopyableTextWithTooltip;
